import type { ClientLocationConfirmationSource } from './types';

/** Attestation copy shown to the client — version when this text changes. */
export const LOCATION_ATTESTATION_TEXT =
  'I confirm that I am physically located at this address for today\u2019s session.';
export const LOCATION_ATTESTATION_VERSION = '1.0';

export const CLIENT_LOCATION_SOURCE_LABELS: Record<ClientLocationConfirmationSource, string> = {
  device_location_prefilled_client_attested: 'Device location prefill + client attestation',
  ip_prefilled_client_attested: 'IP prefill + client attestation',
  manual_client_attested: 'Manual entry + client attestation',
  saved_address_client_attested: 'Saved address + client attestation',
};
